import React, {Component} from "react";
import axios from "axios";
import Error404 from "./Error404";
import EstateTabs from "./EstateTabs";
import EstateInfo from "./EstateInfo";
import {withRouter} from "react-router-dom";
import EstateGallery from "./EstateGallery";
import {Loading} from "./partials/Global/Loading";
import {CopyRight} from "./partials/Global/CopyRight";
import {FooterBody} from "./partials/Global/FooterBody";
import {Navigation} from "./partials/Global/Navigation";
import {DottedLoading} from "./partials/Global/DottedLoading";
import {ProgressScrollButton} from "./partials/Global/ProgressScrollButton";

class EstateDetail extends Component {
    constructor(props) {
        super(props);

        const query = new URLSearchParams(this.props.location.search);
        const file = Object.fromEntries([...query]);
        let auction = {};
        if (file.auction_id) {
            auction = {
                id: file.auction_id,
                auction_file_id: file.id,
                is_active: file.auction_is_active
            };
        }

        this.state = {
            file,
            auction,
            agents: [],
            images: [],
            isLoading: true,
            fileId: this.props.match.params.id
        };
    }

    componentDidMount() {
        (async () => {
            await this.getFile();
        })();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.setState({fileId: this.props.match.params.id});
        }
        if (this.state.fileId !== prevState.fileId) {
            this.getFile();
        }
    }

    getFile = async () => {
        const response = await axios.post(
            process.env.REACT_APP_API_URL +
            process.env.REACT_APP_FILE_DETAIL +
            this.state.fileId + ".json",
            {
                apiKey: process.env.REACT_APP_API_PUBLIC_TOKEN
            }
        );

        if (response.status === 200 && response.data.result.status === true && response.data.result.data) {
            this.setState({
                file: response.data.result.data.file,
                agents: response.data.result.data.agents,
                images: response.data.result.data.images,
                isLoading: false
            });
        } else {
            return false;
        }
        return true;
    };

    isActiveAuction(auction) {
        return Object.keys(auction).length !== 0 && auction.is_active === 'true';
    }

    render() {
        let request_url = null;
        if (this.isActiveAuction(this.state.auction)) {
            request_url = process.env.REACT_APP_API_URL + "/users/dashboard#/requests/add/" + this.state.auction.id + "/" + this.state.file.id;
        }
        // if (this.state.urlValidation !== true) return <Error404/>;
        return (
            <>
                <Loading/>
                <ProgressScrollButton/>
                <Navigation/>
                <main className="main-bg">
                    <section className="product-details section-ptb">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-lg-4">
                                    {!this.state.isLoading
                                        ? <EstateGallery images={this.state.images}/>
                                        : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                                </div>
                                <div className="col-lg-6 offset-lg-1">
                                    <EstateInfo file={this.state.file} request_url={request_url}/>
                                </div>
                            </div>
                            <div className="row justify-content-center mt-100">
                                <div className="col-lg-11">
                                    <div className="overview" id="tabs">
                                        <ul className="rest tab-links mb-30">
                                            <li className="item-link current" data-tab="tabs-1">
                                                <h6>امکانات</h6>
                                            </li>
                                            <li className="item-link" data-tab="tabs-2">
                                                <h6>موقعیت ملک</h6>
                                            </li>
                                            <li className="item-link" data-tab="tabs-3">
                                                <h6>تماس با دفتر فروش | نمایندگان منطقه</h6>
                                            </li>
                                        </ul>
                                        {!this.state.isLoading
                                            ? <EstateTabs agents={this.state.agents} file={this.state.file}/>
                                            : <div className='mt-30 mb-80 text-center' style={{marginRight: '49%'}}><DottedLoading/></div>}
                                    </div>
                                </div>
                            </div>
                            {/*{this.isActiveAuction(this.state.auction)
                                ? <div className="sticky-button mt-30">
                                    <a href={request_url} className="butn butn-md butn-bord radius-30" style={{cursor: 'pointer'}}>
                                        <span className="text"> درخواست شرکت در مزایده الکترونیک</span>
                                    </a>
                                </div>
                                : ''
                            }*/}
                        </div>
                    </section>
                </main>
                <footer className="pt-80 sub-bg">
                    <FooterBody/>
                    <CopyRight/>
                </footer>
            </>
        );
    }
}

export default withRouter(EstateDetail);
